import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const PRESET_REASONS = [
  "Zu teuer",
  "Kein Bedarf mehr",
  "Konkurrenz gewonnen",
  "Falscher Zeitpunkt",
  "Kein Entscheider erreicht",
  "Sonstiges",
];

/**
 * Modal for selecting a lost-reason. onConfirm(reason: string)
 */
export default function LostReasonModal({ open, onClose, onConfirm }) {
  const [selected, setSelected] = useState("");
  const [custom, setCustom] = useState("");

  const handleConfirm = () => {
    const reason = selected === "Sonstiges" ? (custom || "").trim() : selected;
    if (!reason) return;
    onConfirm(reason);
    setSelected("");
    setCustom("");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md rounded-sm" data-testid="lost-reason-modal">
        <DialogHeader>
          <DialogTitle className="font-heading font-bold">Verlust-Grund</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground -mt-1">Warum ist der Lead verloren? (hilft fürs Reporting)</p>
        <div className="space-y-2">
          {PRESET_REASONS.map(r => (
            <label key={r} className={`flex items-center gap-3 p-2.5 border rounded-sm cursor-pointer transition-colors ${selected === r ? "border-foreground bg-muted" : "border-border hover:bg-muted/50"}`} data-testid={`reason-${r.toLowerCase().replace(/\s/g, "-")}`}>
              <input type="radio" name="reason" value={r} checked={selected === r} onChange={() => setSelected(r)} className="accent-foreground" />
              <span className="text-sm">{r}</span>
            </label>
          ))}
          {selected === "Sonstiges" && (
            <div className="pl-9">
              <Label className="text-xs uppercase tracking-wide text-muted-foreground">Beschreibe</Label>
              <Input value={custom} onChange={e => setCustom(e.target.value)} placeholder="z.B. Geschäftsaufgabe..." className="rounded-sm" data-testid="reason-custom" />
            </div>
          )}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} className="rounded-sm">Abbrechen</Button>
          <Button
            onClick={handleConfirm}
            disabled={!selected || (selected === "Sonstiges" && !custom.trim())}
            className="rounded-sm"
            data-testid="confirm-lost-reason"
          >
            Als verloren markieren
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
